export const FILTER_TYPES = Object.freeze({
  BUILDER: 'builder',
  EPOCH: 'epoch',
  REGION: 'region',
  STREET: 'street',
  TYPE: 'type',
  FOCUS: 'focus'
})

export const ACTIVE_FILTERS_LABELS_COUNT = 2